/*
 * @Author: KellyYang
 * @Date: 2022-06-28 10:09:17
 * @LastEditors: KellyYang
 * @Description: 信用评估
 */
import React, { Fragment, useState, useEffect } from "react";
import banner from "@/assets/img/grade-page/grade-banner1.jpg";
import banner1 from "@/assets/img/grade-page/grade-banner2.png";
import infoBg from "@/assets/img/grade-page/info-bg.jpg";
import h5Banner from "@/assets/img/case-page/h5-case-banner.png";
import { isMobile, getParameters } from '@/utils/utils';
import { Spin } from 'antd';
import axios from 'axios'
import './index.less';

const GradeData = () => {
  const [detailData, setDetailData] = useState([
    { label: '企业名称', key: 'entName' },
    { label: '信用等级', key: 'creditRate' },
    { label: '证书编号', key: 'certNo' },
    { label: '颁发日期', key: 'issuedTime' },
    { label: '有效日期', key: 'effectiveTime' },
    // { label: '信用分数', key: 'creditScore' },
    { label: '评估机构', key: 'ratingAgencies' },
    // { label: '评级时间', key: 'applyTime' },
  ])
  const [loading, setLoading] = useState(false)
  const [detailDataObj, setDetailDataObj] = useState()
  const { certno } = getParameters() || {}

  const getDetail = () => {
    setLoading(true)
    axios.request({
      url: '/jypt/api/creditevaluation/queryCertInfoH5',
      baseURL: 'https://jypt.jinyucredit.com',
      method: 'post',
      data: { certno }
    }).then(({ data: resData }) => {
      const { code, data } = resData || {}
      if (code === 0) {
        setDetailDataObj(data)
      }
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  useEffect(() => {
    getDetail()
  }, [certno])
  return (
    <div>
      <div className={isMobile() ? 'grade-page-mobile grade-page' : 'grade-page'}>
        <section>
          <div className="grade-page-header" style={{ backgroundImage: `url(${banner})` }}>
            <img src={banner1} className="page-banner" alt="" />
            {/* <div className="header-box">
              <div className="banner-title">
                <span>
                  效率赋能、数据赋能、风险赋能
                </span>
              </div>
              <div className="banner-subtitle">
                <span>
                  为小微企业提供融资解决方案，为银行提供数字化转型服务
                </span>
              </div>
            </div> */}
          </div>
        </section>
        <Spin spinning={loading}>
          <section className="info-warp">
            <img src={infoBg} className="info-bg" alt="" />
            <div className="info-warp-box">
              <div className="detail-title">企业信用等级评估</div>
              <div className="detail-list-box">
                <div className="detail-list">
                  {
                    detailData.map((item, index) => (
                      <div className="detail-li" key={item.key}>
                        <div className="detail-li-label">{item.label}：</div>
                        <div className="detail-li-value">{detailDataObj?.[item.key] || '-'}</div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </section>
        </Spin>
      </div>
    </div>
  )
}

export default GradeData;
